<template>
  <div class="conslutant-wrapper is-one-third column">
    <div class="consultant">
      <img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteConsultant(consultant.id)"/>
      <div class="centered switch-wrapper">
        <b-switch v-model="consultant.isHidden" @change="updateConsultant(consultant)">Скрыть консультанта</b-switch>
      </div>
      <div class="is-flex centered">
        <div class="rounded-photo-wrapper agency-photo centered" v-bind:style="photoContainerStyle">
        <input type="file" id='photo' @change='loadPhoto' hidden ref="loadPhotoButton" />
        <div v-if="!consultant.photo" @click="handleLoadPhoto">
          <span>Загрузить фото</span>
        </div>
        <img v-else src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteConsultantPhoto(consultant.id)"/>
      </div>
      </div>
      <b-field label="Имя консультанта ">
          <b-input placeholder="Имя консультанта" v-model="consultant.name" @change="updateConsultant(consultant)"/>
      </b-field>
      <b-field label="email консультанта" v-if="consultant.type==='common'">
          <b-input placeholder="email" v-model="consultant.email" @change="updateConsultant(consultant)"/>
      </b-field>
      <b-field label="телефон консультанта" v-if="consultant.type==='common'">
          <b-input placeholder="телефон консультанта" v-model="consultant.phone" @change="updateConsultant(consultant)"/>
      </b-field>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'Consultant',
    data () {
      return {}
    },
    props: {
      consultant: {
        type: Object,
        required: true
      }
    },
    computed: {
      photoContainerStyle () {
        return this.consultant.photo
        ? {background: !this.base64photo
          ? `url(/upload/photos/${this.consultant.photo})`
          : `url(${this.base64photo})`}
        : {background: ''}
      }
    },
    methods: {
      ...mapActions(['loadConsultantPhoto', 'deleteConsultantPhoto', 'deleteConsultant', 'updateConsultant', 'addConsultantPhoto']),
      loadPhoto (e) {
        const reader = new FileReader()
        reader.readAsDataURL(e.target.files[0])
        const formData = new FormData()
        const file = e.target.files[0]
        formData.set('avatar', file)
        reader.onload = (e) => {
          this.consultant.photo = {
            id: this.consultant.id,
            data: formData
          }
          this.base64photo = e.target.result
          this.addConsultantPhoto(this.consultant.photo)
          this.updateConsultant(this.consultant)
        }
      },
      handleLoadPhoto () {
        if (!this.consultant.photo) {
          this.$refs.loadPhotoButton.click()
        }
      }
    }
  }
</script>

<style scoped>
.consultant-wrapper {
  padding: 5px;
}

.consultant {
  background: #eeeeee;
  position: relative;
  padding: 10px;
}

.rounded-photo-wrapper {
  height: 75px;
  width: 75px;
  font-size: 13px;
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-size: contain !important;
}

.delete-icon {
  top: -10px;
  right: -10px;
}

.switch-wrapper {
  margin: 5px 0 20px;
}
</style>



// WEBPACK FOOTER //
// Consultant.vue?142fb6e2